import React from 'react';
import { StarIcon, CheckCircleIcon, ChevronDownIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className="pt-24 pb-12 px-4 md:pt-32 md:pb-20 max-w-6xl mx-auto relative" data-id="element-61">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-62">
        <div className="space-y-6" data-id="element-63">
          <div className="flex items-center space-x-2 text-brand-gold" data-id="element-64">
            <div className="flex" data-id="element-65">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-66" />)}
            </div>
            <span className="text-sm text-gray-300 font-medium" data-id="element-67">
              Verificado por +1,000 hombres
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-heading text-white leading-[1.1] uppercase" data-id="element-68">
            Anunciando el método más completo del mundo para{' '}
            <span className="text-brand-red" data-id="element-69">durar 30+ minutos en la cama</span>{' '}
            y controlar tu eyaculación
          </h1>

          <p className="text-lg text-gray-300 font-medium border-l-4 border-brand-gold pl-4" data-id="element-70">
            (Asegurate de leer hasta el final. Puede tardar unos segundos en
            “hacer click” en tu cabeza)
          </p>

          <div className="flex items-end space-x-4 mb-2" data-id="element-71">
            <span className="text-2xl text-gray-500 line-through font-bold" data-id="element-72">
              $42.990
            </span>
            <span className="text-4xl text-brand-green font-heading" data-id="element-73">
              $19.990
            </span>
          </div>

          <div className="bg-gray-900/80 border border-gray-800 p-5 rounded-xl space-y-3" data-id="element-74">
            <div className="flex items-center text-gray-200 font-medium" data-id="element-75">
              <CheckCircleIcon className="w-5 h-5 text-brand-green mr-3 flex-shrink-0" data-id="element-76" />
              <span data-id="element-77">Acceso inmediato</span>
            </div>
            <div className="flex items-center text-gray-200 font-medium" data-id="element-78">
              <CheckCircleIcon className="w-5 h-5 text-brand-green mr-3 flex-shrink-0" data-id="element-79" />
              <span data-id="element-80">Sin pagos mensuales</span>
            </div>
            <div className="flex items-center text-gray-200 font-medium" data-id="element-81">
              <CheckCircleIcon className="w-5 h-5 text-brand-green mr-3 flex-shrink-0" data-id="element-82" />
              <span data-id="element-83">Método paso a paso</span>
            </div>
          </div>

          <div className="space-y-3" data-id="element-84">
            <a href="[CART_LINK]" className="block w-full text-center bg-brand-red hover:bg-brand-redHover text-white font-heading text-2xl py-5 px-8 rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-85">
              AGREGAR AL CARRITO AHORA
            </a>
            <p className="text-center text-brand-gold font-bold text-sm" data-id="element-86">
              💥 Oferta de Acceso de por Vida
            </p>
          </div>

          <p className="text-xs text-center text-gray-500 font-medium" data-id="element-87">
            ⚠️ Me reservo el derecho de cerrar esta oferta en cualquier momento.
          </p>
        </div>

        <div className="relative aspect-[4/5] md:aspect-square bg-gray-900 rounded-2xl border border-gray-800 overflow-hidden flex items-center justify-center shadow-2xl" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/jZzCGDay7Fn6HGnbfaW2Mh/foto_ebook.jpg" alt="Método Control Total" className="absolute inset-0 w-full h-full object-cover" data-id="element-89" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" data-id="element-90" />
          <p className="relative z-10 text-white font-bold text-lg uppercase tracking-wide text-center px-6 mt-auto pb-8 drop-shadow-lg" data-id="element-91">
            LEÉ ESTO HASTA EL FINAL Y OBTENÉ ACCESO AL SISTEMA COMPLETO
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-10 animate-bounce hidden md:block" data-id="element-92">
        <ChevronDownIcon className="w-8 h-8 text-gray-500" data-id="element-93" />
      </div>
    </motion.section>;
}